import { type QueryFunctionContext, useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';
import * as qs from 'qs';

import type { IActionItem } from '@model/actionItem';

import type { IEquipmentItem } from '@pages/ManageEquipment/model/equipmentsList';

import { apiClient } from '@services/apiClient';

const equipmentsCheckKey = (equipmentIds: Array<number>) => ['equipmentsCheck', equipmentIds];

const equipmentsCheckFn = ({ queryKey }: QueryFunctionContext<ReturnType<typeof equipmentsCheckKey>>) => {
  return apiClient.get(`${APP_API_URL}equipments/check`, {
    params: {
      equipments: queryKey[1],
    },
    paramsSerializer: {
      serialize: (params) => qs.stringify(params),
    },
  });
};

const equipmentsCheckSelect = ({ data }: AxiosResponse<{ active_action_items: Array<IActionItem> }>) => {
  if (!data?.active_action_items?.length) {
    return null;
  }
  const regularList: Array<IActionItem> = [];
  const hardwareList: Array<IActionItem> = [];
  data.active_action_items.forEach((point) => {
    if (point.type === 'regular') regularList.push(point);
    if (point.type === 'waitesWireless') hardwareList.push(point);
  });

  return {
    regularList,
    hardwareList,
  };
};

export const useEquipmentsCheckQuery = ({ equipments }: { equipments: Array<IEquipmentItem> }) => {
  const equipmentIds = equipments.map((s) => s.id);
  return useQuery({
    queryKey: equipmentsCheckKey(equipmentIds),
    queryFn: equipmentsCheckFn,
    select: equipmentsCheckSelect,
  });
};
